import { isParamEmpty, validatePercentage } from "@/filters";
/**
 * @param {string} path
 * @returns {Boolean}
 */
 export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}

// 校验输入必须为数字
export var validateNumber = (rule, value, callback) => {
    if (isParamEmpty(value) && rule['required'] === true) { // 值为空 && 必填
        return callback(new Error(`请输入${rule.msg}`))
    } else if (isParamEmpty(value) && rule['required'] === false) { // 值为空 && 非必填
        callback()
    } else {
        if (!/^\d+$|^\d+[.]?\d+$/.test(value)) {
            callback(new Error('只能输入数字类型'))
        } else {
            callback()
        }
    }
}

// 校验输入必须为数字且不等于大于6位 弹出是否确认提示
export var validateNumberLength = (rule, value, callback) => {
    if (String(value).replace(/\s+/g, "") === "") {
        return callback(new Error(`请输入${rule['msg']}`))
    } else {
        if (!/^\d+$|^\d+[.]?\d+$/.test(value)) {
            callback(new Error('只能输入数字类型'))
        } else if (String(value).split('.')[0].length >= 6 && !rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag']){
            let show = true

            rule['currentThis'].$confirm(`您确定填写的${rule.msg}为 ${value} <span style='color: red; font-weight:bold;font-size: 16px;'>万元 </span>吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
                confirmButtonClass: 'bntDisabled',
                beforeClose:(action,instance,closeFn)=>{
                    if(action == 'confirm' && show){
                        return
                    }else if(action == 'cancel'){
                        closeFn()
                    }else {
                        closeFn()
                    }

                }
            }).then(() => {
                rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag'] = true;
                callback()
            }).catch(() => {
                rule['currentThis'][rule['currentFormName']][rule['currentFieldName']] = ""
                return callback(new Error(`请输入${rule['msg']}`))
            });

            setTimeout(()=> {
                let buttonDom = document.querySelector(".bntDisabled")
                buttonDom.getAttributeNode('class').value = 'el-button el-button--default el-button--small el-button--primary bntDisabled bnt-disabled'
            },500)

            setTimeout(()=> {
                show = false
                let buttonDom = document.querySelector(".bntDisabled")
                console.log()
                buttonDom.getAttributeNode('class').value = 'el-button el-button--default el-button--small el-button--primary bntDisabled'
            },5000)
        } else {
            callback()
        }
    }
}

// 校验输入必须为数字且不等于大于6位 弹出是否确认提示 且可为正整数、负数、零
export var validatePLusMinusNumber = (rule, value, callback) => {
    if (String(value).replace(/\s+/g, "") === "") {
        return callback(new Error(`请输入${rule['msg']}`))
    } else {
        if (!/^-?(0|[1-9]\d*)(\.\d{0,2})?$/.test(value)) {
            callback(new Error('只能输入数字类型，且只能输入两位小数'))
        } else {
            // if (String(value).indexOf('.') !== -1 && String(value).indexOf('-') === -1) { // 有小数 & 没负数
            //     if (String(value).split('.')[0].length >= 6 && !rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag']) {
            //         rule['currentThis'].$confirm(`您确定填写的${rule.msg}为 ${value} 万元吗？`, '提示', {
            //             confirmButtonText: '确定',
            //             cancelButtonText: '取消',
            //             type: 'warning'
            //         }).then(() => {
            //             rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag'] = true;
            //             callback()
            //         }).catch(() => {
            //             rule['currentThis'][rule['currentFormName']][rule['currentFieldName']] = ""
            //             return callback(new Error(`请输入${rule['msg']}`))
            //         });
            //     } else {
            //         callback()
            //     }
            // } else if (String(value).indexOf('-') !== -1 && String(value).indexOf('.') === -1) { // 有负数 & 没小数-
            //     if (String(value).split('-')[1].length >= 6 && !rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag']) {
            //         rule['currentThis'].$confirm(`您确定填写的${rule.msg}为 ${value} 万元吗？`, '提示', {
            //             confirmButtonText: '确定',
            //             cancelButtonText: '取消',
            //             type: 'warning'
            //         }).then(() => {
            //             rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag'] = true;
            //             callback()
            //         }).catch(() => {
            //             rule['currentThis'][rule['currentFormName']][rule['currentFieldName']] = ""
            //             return callback(new Error(`请输入${rule['msg']}`))
            //         });
            //     } else {
            //         callback()
            //     }
            // } else if (String(value).indexOf('.') !== -1 && String(value).indexOf('-') !== -1) { // 负数 & 小数
            //     if (String(String(value).split('.')[0]).split('-')[1].length >= 6 && !rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag']) {
            //         rule['currentThis'].$confirm(`您确定填写的${rule.msg}为 ${value} 万元吗？`, '提示', {
            //             confirmButtonText: '确定',
            //             cancelButtonText: '取消',
            //             type: 'warning'
            //         }).then(() => {
            //             rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag'] = true;
            //             callback()
            //         }).catch(() => {
            //             rule['currentThis'][rule['currentFormName']][rule['currentFieldName']] = ""
            //             return callback(new Error(`请输入${rule['msg']}`))
            //         });
            //     } else {
            //         callback()
            //     }
            // } else if (String(value).length >= 6 && !rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag']) {
            //     rule['currentThis'].$confirm(`您确定填写的${rule.msg}为 ${value} 万元吗？`, '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         rule['currentThis'][rule['rulesName']][rule['currentFieldName']][0]['flag'] = true;
            //         callback()
            //     }).catch(() => {
            //         rule['currentThis'][rule['currentFormName']][rule['currentFieldName']] = ""
            //         return callback(new Error(`请输入${rule['msg']}`))
            //     });
            // } else {
                callback()
            // }
        }
    }
}

// 校验输入必须为数字，两位小数且不大于100
export var validateRate = (rule, value, callback) => {
    if (isParamEmpty(value)) {
        return callback(new Error(`请输入${rule['msg']}`))
    } else {
        if (!validatePercentage(value)) {
            callback(new Error('只能是数字或小数，最多输入2位小数且不得超过100！'))
        } else {
            callback()
        }
    }
}

// 联系方式，手机号，座机
export var validateContactWay = (rule, value, callback) => {
    if (!value) {
        return callback(new Error(`请输入${rule['msg']}`))
    } else {
        if (!/^(0|86|17951)?(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-3,5-9])\d{8}$|^(0\d{2,3}\-)([2-9][0-9]{6,7})+(\-\d{1,4})?$/.test(value)) {
            callback(new Error(`请输入正确的${rule['msg']}`))
        } else {
            callback()
        }
    }
}

/**
 * 根据数组中元素的属性名排序
 * @param {数组} arrays 
 * @param {数组元素的属性名} key 
 * @returns 排序后的数组，小的在前
 */
export function sortArrayByKey(arrays, key){
  let newArrays = arrays.slice(0)
  newArrays.sort(function(a, b) {
      if (typeof a[key] === "string") {
          let x = a[key].toLowerCase()
          let y = b[key].toLowerCase()
          return x < y ? -1 : x > y ? 1 : 0
      }else if(typeof a[key] === "number")
          return a[key] - b[key]
      else return a[key] - b[key]    
  })
  return newArrays
}



// WEBPACK FOOTER //
// ./src/utils/validate.js